<div class="border-top">
  <div class="guts-p-full-1">
    <div *ngIf="!isLoading; else skeleton">
      <h4 class="h3" data-dgat="monthly-activity-ttl">
        {{ i18n.DashboardNav_MonthlyActivity }}
      </h4>
      <div class="l_flex l_flex-column monthly-activity-wrapper">
        <div
          *ngFor="let activity of monthlyActivity"
          class="l_flexbar guts-m-b-1-half"
          data-dgat="monthly-activity-7c8"
          [attr.aria-label]="getAriaLabelForMonthlyActivity(activity)"
        >
          <df-icon
            [icon]="activity.icon"
            size="small"
            class="color-white guts-m-r-half monthly-activity-icon"
          ></df-icon>
          <span class="title par par--small par--light_a">{{
            activity.label
          }}</span>
          <div
            class="guts-m-l-auto par par--small font-semibold l_flexbar"
            [ngClass]="{
              'color-success-dark': activity.difference > 0,
              'color-error-dark': activity.difference < 0,
              'color-ebony-a61': activity.difference === 0
            }"
          >
            {{ activity.monthlyCount }}
            <df-icon
              *ngIf="activity.difference !== 0"
              [icon]="activity.difference > 0 ? 'caret-up' : 'caret-down'"
              size="small"
            ></df-icon>
          </div>
        </div>
      </div>
      <!-- View All Insights -->
      <a
        [attr.href]="insightsUrl"
        class="link par--small font-semibold"
        data-dgat="monthly-activity-991"
      >
        <div class="l_flexbar">
          <div class="guts-m-r-1">
            {{ i18n.DashboardNav_AllActivity }}
          </div>
          <df-icon icon="chevron-right" size="small"></df-icon>
        </div>
      </a>
    </div>

    <ng-template #skeleton>
      <div class="skeleton-container">
        <div
          class="skeleton__line bg-animate grid__col-7 guts-m-b-1-half guts-p-full-0"
        ></div>

        <div
          *ngFor="let i of [1, 2, 3]"
          class="l_flexbar guts-m-b-1-half l_flex-middle"
          data-dgat="monthly-activity-dff"
        >
          <div class="skeleton__circle skeleton__circle bg-animate"></div>
          <div
            class="skeleton__line bg-animate grid__col-4 guts-m-l-1 guts-p-full-0"
          ></div>
          <div
            class="skeleton__line bg-animate grid__col-1 guts-p-full-0 guts-m-l-auto"
          ></div>
        </div>

        <div class="skeleton__line bg-animate grid__col-3 guts-p-full-0"></div>
      </div>
    </ng-template>
  </div>
</div>
